var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{scopedSlots:_vm._u([{key:"other",fn:function(){return [_c('DialogLoginLine'),_vm._v(" "),_c('AdvertisingImages',{attrs:{"device":"desktop"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }